import { Box, SxProps, Typography } from "@mui/material";
import { ReactNode } from "react";
import { RequiredOneInSpecifiedKeys } from "../types";

type Props = RequiredOneInSpecifiedKeys<
  {
    title?: string;
    description?: string;
    children: ReactNode;
    titleComponent?: ReactNode;
    sx?: SxProps;
    color?: string;
  },
  "title" | "titleComponent"
>;

/**
 * 破線で囲むコンポーネント
 * @param root0 コンポーネントのプロップス
 */
export default function Surround({
  title,
  description,
  children,
  titleComponent,
  sx,
  color,
}: Props) {
  return (
    <Box
      mt={1}
      mb={1}
      pt={0.5}
      border="dashed 2px"
      borderRadius={2}
      borderColor={color ?? "#8B4513"}
      position="relative"
      sx={sx}
    >
      {titleComponent ?? (
        <Box
          position="absolute"
          display="flex"
          flexDirection="row"
          top={-10}
          left={8}
          px={1}
          sx={{ backgroundColor: "var(--white)" }}
        >
          <Typography fontSize={14} color={color ?? "#8B4513"}>
            {title}
          </Typography>
          {description && (
            <Typography fontSize={11} color="rgb(50,50,50)" margin="2px 0 0 4px">
              {description}
            </Typography>
          )}
        </Box>
      )}
      {children}
    </Box>
  );
}
